// DuckDB テーブルのジオメトリを GeoJSON FeatureCollection に変換し、
// あわせて自動ズーム用のバウンディングボックスを取得する。
//
// 役割: 地図描画（deck.gl GeoJsonLayer）が消費する GeoJSON を生成する。
//       get_layer_geojson ツールと手動取込フローの双方から使われる。
// 関係: db.js の query() を使用。出力 GeoJSON は Layers/index.js の renderLayers() に渡る。
//
// 注意: 大容量レイヤーは GeoJSON 全量変換が重くなる（plan.md §9）。件数・サイズ上限は
//       呼び出し側（ツール層）で設ける方針。ここでは素直に全件変換する。
//
// 流用元: reference/deckgl-duckdb-template/src/duckdb/toGeoJSON.js
import { query } from './db'

// テーブルを FeatureCollection に変換する。
// 戻り値: { featureCollection, bounds }
//   bounds: [[minX, minY], [maxX, maxY]]（データが空なら null）
export async function tableToGeoJSON(table, geomColumn) {
  const g = `"${geomColumn}"`

  const rows = await query(
    `SELECT ST_AsGeoJSON(${g}) AS __geometry, * EXCLUDE (${g}) FROM "${table}";`,
  )

  const features = []
  for (const row of rows) {
    const { __geometry, ...properties } = row
    if (!__geometry) continue
    features.push({
      type: 'Feature',
      geometry: JSON.parse(__geometry),
      properties,
    })
  }

  const featureCollection = { type: 'FeatureCollection', features }

  const [extent] = await query(
    `SELECT min(ST_XMin(${g})) AS minx, min(ST_YMin(${g})) AS miny, ` +
      `max(ST_XMax(${g})) AS maxx, max(ST_YMax(${g})) AS maxy FROM "${table}";`,
  )

  let bounds = null
  if (extent && extent.minx != null && Number.isFinite(Number(extent.minx))) {
    bounds = [
      [Number(extent.minx), Number(extent.miny)],
      [Number(extent.maxx), Number(extent.maxy)],
    ]
  }

  return { featureCollection, bounds }
}
